module.exports = __webpack_public_path__ + "img/euro-logo-default.80e3d76d.png";